const validateSmartCotiForm = (formData) => {
  const errors = {};

  if (!formData.requiredQuantity || formData.requiredQuantity === '0') {
    errors.requiredQuantity = 'La cantidad es requerida';
  }

  if (!formData.maxUnitPrice || formData.maxUnitPrice === '0') {
    errors.maxUnitPrice = 'El precio máximo por unidad es requerido';
  }

  if (!formData.requiredProduct || formData.requiredProduct.trim() === '') {
    errors.requiredProduct = 'Por favor describa el producto que necesita';
  }

  if (!formData.company || formData.company.trim() === '') {
    errors.company = 'La empresa es requerida';
  }

  if (!formData.name || formData.name.trim() === '') {
    errors.name = 'El nombre es requerido';
  }

  if (!formData.phone || formData.phone.length < 7) {
    errors.phone = 'El teléfono debe tener al menos 7 dígitos';
  }

  if (!formData.email || !/\S+@\S+\.\S+/.test(formData.email)) {
    errors.email = 'El correo electrónico no es válido';
  }

  return errors;
};

export default validateSmartCotiForm;